import { useTranslation } from 'react-i18next';
import { useShippingSoon } from '~/api';
import { formatDate, sellerLabel } from '~/utils';
import { OrderStatusBadge } from '~/components/ui/OrderStatusBadge';
import { ShipmentOrdersColumn } from './shared/ShipmentOrdersColumn';

export function ShippingSoonColumn() {
  const { t } = useTranslation('dashboard');
  const { data, isLoading, isError } = useShippingSoon();

  const orders = data?.shippingSoon ?? [];

  return (
    <ShipmentOrdersColumn
      title={t('dashboard.shipping_soon.title')}
      subtitle={t('dashboard.shipping_soon.subtitle')}
      badge={orders.length}
      footerLink="/buyer-orders"
      footerLabel={t('dashboard.shipping_soon.footer')}
      orders={orders}
      isLoading={isLoading}
      isError={isError}
      emptyText={t('dashboard.shipping_soon.empty')}
      errorText={t('dashboard.shipping_soon.error')}
      getOrgLabel={(order) => sellerLabel(order.sellingOrganization)}
      renderRowTopRight={(order) => (
        <OrderStatusBadge status={order.status} size="caption" />
      )}
      renderDateMeta={(order) => ({
        row3Right: order.deliveryStartDate ? (
          <p className="text-xs font-medium text-neut-sec">
            {t('dashboard.shipping_soon.expected_arrival')}
          </p>
        ) : null,
        row4Right: order.deliveryStartDate ? (
          <p className="text-xs font-medium text-neut-400">
            {formatDate(order.deliveryStartDate)}
          </p>
        ) : null,
      })}
    />
  );
}
